var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassdoorReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.glassdoor{fill:url(#glassdoor-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glassdoor-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aaced7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25529,
    stopColor: "#59bb8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#0daa41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d775f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "glassdoor",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M57.60514,47.12855l-4.35086-.86948-2.17142-3.86933c-.47448-.84533-1.69134-.84533-2.16572,0l-2.17142,3.86933-4.35086.86948c-.9506.18997-1.32667,1.34724-.66927,2.05968l3.00893,3.2608-.51765,4.40658c-.11309.96277.87141,1.67811,1.75209,1.27297l4.031-1.85397,4.03109,1.85397c.88068.40514,1.86508-.3102,1.75199-1.27297l-.51755-4.40658,3.00893-3.2608c.65739-.71244.28133-1.86972-.66927-2.05968Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M39.69495,61.9383v-29.10484h27.86831v-1.11578c0-3.37918-2.73934-6.11856-6.11853-6.11856h-22.88947c-3.37915,0-6.11853,2.73937-6.11853,6.11856v30.22062h7.25822Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M60.30508,38.14193v29.02461h-17.86004v.08023h-10.0083v1.03558c0,3.37918,2.73937,6.11853,6.11853,6.11853h22.88947c3.37918,0,6.11853-2.73934,6.11853-6.11853v-30.14042h-7.25818Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassdoorReviewsScraper);
export default __webpack_public_path__ + "static/media/glassdoor-reviews-scraper.dffd7369ad523175c4d9a82950db7f0d.svg";
export { ForwardRef as ReactComponent };